// Font family mapping to ensure Tailwind classes are included in build
export const fontFamilyClasses = {
  sans: 'font-sans',
  arial: 'font-arial',
  calibri: 'font-calibri',
  roboto: 'font-roboto',
  comforta: 'font-comforta',
  'times-new-roman': 'font-times-new-roman',
  oswald: 'font-oswald',
  verdana: 'font-verdana',
  'comic-sans': 'font-comic-sans',
  impact: 'font-impact',
  lato: 'font-lato',
} as const
